<template>
  <div>
  <admin-header />
    <div class="outside">
      <div class="main content">

        <div class="top_case-one">
          <div class="nav-top">
          <!-- 统计 -->
                <img class="gonggao" src="~assets/icons/gonggao.png" style="vertical-align:middle;" />
                <span id="">{{ navigator }}</span>
	  </div>

          <el-main style="width: 100%;margin-top:10px;">
            <div class="item">
		<div class="typelist">
		    <ul>
		      <li v-for="(nItem, nKey) in typelist" :class="{'active': typedata === nItem.id}">
			<a href="javascript:;"  @click="getNotices(nItem.id)">{{ nItem.name }}</a>
		      </li>
		    </ul>
		</div>
		<!-- 公告列表 开始  -->
              <div class="noticelist">
		    <ul>
		      <li v-for="(nItem, nKey) in noticelist">
			<a href="javascript:;"  @click="showNotice(nItem.id)">
			<span class="tm">{{ timeConverDate(nItem.createtime) }}</span>
			<div class="litt">{{ nItem.title }}</div>
			</a>
		      </li>
		    </ul>

              </div>
		<!-- 公告列表 结束  -->

		<!-- 分页 开始  -->
	      <div class="pagination" style="text-align:right;padding:5px 30px;">
		<el-pagination
		  background
		  @current-change="currentChange"
		  :page-size="this.pageinfo.per_page"
		  layout="prev, pager, next"
		  :current-page="this.pageinfo.current_page"
		  :total="this.pageinfo.total">
		</el-pagination>
	      </div>
		<!-- 分页 结束  -->

            </div>
          </el-main>
	</div>
      </div>
    </div>

    <el-dialog :title="noticeDetail.title" :visible.sync="noticeDivShow" center :before-close="noticeDivClose" width="90%" top="50px">
      <div :model="noticeInfo">

        <div class="info">
          <div class="info-content" v-html="noticeDetail.content"></div>
        </div>
        <div class="addtime">
          <span>发布时间：{{timeConverDate(noticeDetail.createtime)}}</span><span class="sdf" style="margin-left:15px">{{$store.getters.getSiteInfo.name}}</span>
        </div>
      </div>
    </el-dialog>

    <app-main />

  </div>
</template>

<script>
import { timeConverDate } from 'utils/utils'
import AdminHeader from 'components/baseStructure/AdminHeader'
import AppMain from 'components/baseStructure/AppMain'
// import DialogDetail from 'views/notice/DialogDetail.vue'
// import NoticeListItem from './childComps/NoticeListItem'
import { getNoticeAll, getNoticeSelect, getNoticeList, getNoticeDetail } from 'network/api'

export default {
  components: {
    AdminHeader,
    AppMain,
    // DialogDetail
    // NoticeListItem
  },
  data () {
    return {
      notices: [],
      noticelist: [],
      content: [],
      pageinfo: [],
      activePath: '0', // 被激活的菜单
      typedata: 0,
      currentPage: 0,
      url: '',
      noticeDivShow: false,
      navigator: '',
      noticeDetail: [],
      noticeInfo:{},
      typelist:[
        { id: 1, key: 0, name: '系统公告' },
        { id: 2, key: 1, name: '新手必看' },
        { id: 3, key: 2, name: '常见问题' },
        { id: 4, key: 3, name: '操作视频' }
      ]
    }
  },
  created () {
    this.typedata = this.getQueryString('typedata') ?? 0
    this.getNoticeAll()
    this.getList()
  },
  computed: {
    // 使用时间戳转化函数
    timeConverDate() {
      return timeConverDate
    }
  },
  methods: {
    currentChange (val) {
      this.currentPage = val
      this.getList()
    },
    noticeDivClose(){
      this.noticeDivShow = false
      this.noticeDetail = []
    },
    getNotices(id){
	this.typedata = id
	this.getList()
    },
    // 获取公告列表
    getList(){
	// pos 公告/文章发布位置 1分站后台 2商家中心 3分站首页 4主站首页	
        getNoticeList({
	    typedata: this.typedata,
            page: this.currentPage,
            pos: 2
        }).then((res) => {
            this.noticelist = res.data.data
	    this.pageinfo.total = res.data.total
	    this.pageinfo.per_page = res.data.per_page
	    this.pageinfo.current_page = res.data.current_page
	    this.pageinfo.last_page = res.data.last_page

	    // 系统公告：1=公告,2=新手必看,3=常见问题,4=操作视频
	    var typename = ''
	    switch (this.typedata) {
		case '1':	typename = '系统公告'
			break
		case '2':	typename = '新手必看'
			break
		case '3':	typename = '常见问题'
			break
		case '4':	typename = '操作视频'
			break
	    }
	    if(typename != '')	this.navigator = typename
	    else	this.navigator = '文章公告'
        })
    },
    // 显示公告详情
    showNotice(id) {
      getNoticeDetail({id:id}).then((res) => {
        this.noticeDetail = res.data
        this.noticeDivShow = true
      })
    },
    // 保存激活的菜单状态
    saveNavState (path, id) {
      this.activePath = path
      this.getNoticeAll(id)
    },
    handleOpen (key, keyPath) {
      // console.log(key)
      // console.log(keyPath)
      // this.activePath = ''
      // this.notices.forEach(function (item, k) {
      //   // console.log(typeof (key))
      //   // console.log(typeof (k))
      //   if (key.toString() === k.toString()) {
      //     item.children.forEach(function (subItem, subKey) {
      //       console.log(subKey)
      //       if (subKey === 0) {
      //         console.log(subKey, '-----81----')
      //         const id = subKey
      //         console.log(typeof (id))
      //         this.getNoticeAll() // 从这里重新取下id
      //         this.handelClick()
      //       }
      //     })
      //   }
      // })
    },
    handelClick (subItemId) {
      // console.log(subItemId)
      const id = subItemId
      this.getNoticeAll(id)
    },
    handleClose (key, keyPath) {
      // this.activePath = key
      // console.log(key, keyPath)
    },
    // 获取全部公告
    getNoticeAll (params) {
      getNoticeAll(params).then((res) => {
        if (res.code !== 1) { return this.$message({ message: res.msg, type: 'warning' }) }
        if (params) {
          this.content = res.data
        } else {
          this.notices = res.data.list
          // list = JSON.parse(`[${res.value}]`)
          this.content = res.data.content
        }
      })
    },
    // 获取html页面网址传递参数
    getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }
  }
}
</script>
<style scoped src="styles/views/notice/notice.css">
</style>
<stype scoped>
::v-deep .el-dialog__body {
	padding: 25px 25px 60px;
}
</style>
